import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import AddNewZone from './AddNewZone';
import { handleGetRequest } from '../../services/GetTemplate';
import ZoneDeleteDialog from './ZoneDeleteDialog';

function ZoneManagement() {
    const [zoneList, setZoneList] = useState();
    const [viewBlockDialog, setViewBlockDialog] = useState(false);
    const [viewDeleteDialog, setViewDeleteDialog] = useState(false);
    const [selectedDeleteId, setSelectedDeleteId] = useState(null);
    const [viewAddDialog, setViewAddDialog] = useState(false);
    const [editingZone, setEditingZone] = useState(null);
    const [loadingZoneDetails, setLoadingZoneDetails] = useState(false);
    const [loadingZoneList, setLoadingZoneList] = useState(false);

    const getZoneById = async (id) => {
        const response = await handleGetRequest(`Zone/GetZonebyid?zoneId=${id}`, false);
        if (response?.success === true) {
            return response?.data;
        }
    };

    const getUsers = async () => {
        setLoadingZoneList(true);
        try {
            const response = await handleGetRequest('Zone/getAllZones', false);
            if (response?.success === true) {
                setZoneList(response?.data);
            }
        } finally {
            setLoadingZoneList(false);
        }
    };

    useEffect(() => {
        getUsers();
    }, []);

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="flex align-item-center justify-content-center">
                <Button tooltip="Edit Record" icon="pi pi-pencil" iconPos="center" className="mr-0 p-button-rounded block__button" style={{ borderRadius: '50%', border: 'none' }} onClick={() => openEdit(rowData)} />
                <Button tooltip="Delete Record" icon="pi pi-trash" iconPos="center" className="mr-1 ml--4 p-button-rounded delete__button" style={{ borderRadius: '50%', border: 'none' }} onClick={() => handleDelete(rowData)} />
            </div>
        );
    };

    const openEdit = async (rowData) => {
        setLoadingZoneDetails(true);
        try {
            const zoneData = await getZoneById(rowData.zoneID || rowData.id);
            setEditingZone(zoneData || rowData);
            setViewAddDialog(true);
        } catch (err) {
            // handle error silently or show toast
        } finally {
            setLoadingZoneDetails(false);
        }
    };

    const handleBlock = () => {
        setViewBlockDialog(true);
    };
    const onHideBlockDialog = () => {
        setViewBlockDialog(false);
    };

    const handleDelete = (rowData) => {
        // store selected id and open delete confirmation
        setSelectedDeleteId(rowData?.zoneID || rowData?.id || null);
        setViewDeleteDialog(true);
    };
    const onHideDeleteDialog = () => {
        setViewDeleteDialog(false);
    };

    // Custom dialog header with an explicit close (X) button
    const dialogHeader = (
        <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ fontSize: '1.25rem', fontWeight: 600 }}>{editingZone ? 'Update Zone' : 'Add New Zone'}</div>
            <Button icon="pi pi-times" className="p-button-text" onClick={() => setViewAddDialog(false)} aria-label="Close dialog" />
        </div>
    );
    return (
        <>
            <div className="grid">
                <div className="col-12">
                    <div className="Card__Round pt-5" style={{ border: 'none' }}>
                        <div className="flex justify-between items-center w-full">
                            <div>
                                <h3 className="mb-0">Zone Management</h3>
                                <p className="mt-0" style={{ fontSize: '20px' }}>
                                    Create, update, and oversee parking zones to ensure smooth operations across your facility
                                </p>
                            </div>

                            <div className="flex gap-2 justify-end ml-auto" style={{ width: '30%' }}>
                                <Button
                                    label="Add New"
                                    icon="pi pi-plus"
                                    className="p-button-primary ml-auto Btn__Dark"
                                    onClick={() => {
                                        setEditingZone(null);
                                        setViewAddDialog(true);
                                    }}
                                />
                                {/* <Button label="Export" icon="pi pi-upload" className="p-button-secondary Black__Btn" /> */}
                            </div>
                        </div>

                        <div className="Table__Section mt-6" style={{ position: 'relative' }}>
                            {(loadingZoneDetails || loadingZoneList) && (
                                <div style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.7)', zIndex: 999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <ProgressSpinner style={{ width: '50px', height: '50px' }} />
                                </div>
                            )}
                            <DataTable
                                paginator
                                rows={5}
                                rowsPerPageOptions={[5, 10, 25]}
                                className="datatable-responsive"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                                globalFilterFields={['accountLevelName', 'createuser', 'createdate', 'lkpStatus.statusName']}
                                emptyMessage="No List found."
                                responsiveLayout="scroll"
                                value={zoneList}
                            >
                                <Column field="zoneCode" header="Zone Code" />
                                <Column field="zoneName" header="Zone Name" />
                                {/* <Column field="sector" header="Sector" />*/}
                                {/* <Column field="totalCapacity" header="Total Capacity" /> */}
                                {/* <Column field="address" header="Address" /> */}
                                <Column header="Action" body={(rowData) => actionBodyTemplate(rowData)} className="Table__ActionHeading__CentredAlign" />
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog header={dialogHeader} closable={false} visible={viewAddDialog} style={{ width: '100vw', minHeight: '100vh', maxHeight: '100vh' }} onHide={() => setViewAddDialog(false)}>
                <AddNewZone
                    initialPolygon={editingZone && editingZone.zone && editingZone.zone.boundaryGeoJSON ? JSON.parse(editingZone.zone.boundaryGeoJSON) : null}
                    initialData={editingZone}
                    onClose={(refresh) => {
                        setViewAddDialog(false);
                        if (refresh) {
                            // refresh list after successful save/update
                            getUsers();
                        }
                    }}
                />
            </Dialog>
            <Dialog visible={viewDeleteDialog} style={{ width: '30rem' }} onHide={onHideDeleteDialog}>
                <ZoneDeleteDialog
                    onHideDeleteDialog={onHideDeleteDialog}
                    idToDelete={selectedDeleteId}
                    onDeleted={() => {
                        // refresh list after successful delete
                        getUsers();
                        setSelectedDeleteId(null);
                    }}
                />
            </Dialog>
        </>
    );
}

export default ZoneManagement;
